import { Button } from "@/project/karuna/components/ui/button"; // @ts-ignore - button is not a valid module
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "@/project/karuna/assets/ki-logo.png"; // @ts-ignore - assets is not a valid module
import navigationRoutes, {
  useKarunaLink,
} from "@/project/karuna/utils/navigationRoutes";

const PublicNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const getLink = useKarunaLink();
  return (
    <nav className="fixed top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link
            to={getLink(navigationRoutes.HOME)}
            className="flex items-center gap-2"
          >
            <img
              src={logo}
              alt="Karuna International"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden items-center gap-6 md:flex">
            <Link
              to={getLink(navigationRoutes.HOME)}
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              Home
            </Link>
            <Link
              to={getLink(navigationRoutes.ABOUT)}
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              About
            </Link>
            {/* <Link
              to={getLink(navigationRoutes.PROGRAMS)}
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              Programs
            </Link> */}
            <Link
              to={getLink(navigationRoutes.CONTACT)}
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              Contact
            </Link>
            <Link
              to={getLink(navigationRoutes.DONATE)}
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              Donate
            </Link>
            <Link to={getLink(navigationRoutes.DEMO_LOGIN)}>
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
                School Portal
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="p-2 md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="space-y-2 border-t border-border py-4 md:hidden">
            <Link
              to={getLink(navigationRoutes.HOME)}
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full justify-start border-none bg-transparent">
                Home
              </Button>
            </Link>
            <Link
              to={getLink(navigationRoutes.ABOUT)}
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full justify-start border-none bg-transparent">
                About
              </Button>
            </Link>
            <Link
              to={getLink(navigationRoutes.PROGRAMS)}
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full justify-start border-none bg-transparent">
                Programs
              </Button>
            </Link>
            <Link
              to={getLink(navigationRoutes.CONTACT)}
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full justify-start border-none bg-transparent">
                Contact
              </Button>
            </Link>
            <Link
              to={getLink(navigationRoutes.DONATE)}
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full bg-secondary text-secondary-foreground">
                Donate
              </Button>
            </Link>
            <Link
              to={getLink(navigationRoutes.DEMO_LOGIN)}
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full bg-primary text-primary-foreground">
                School Portal
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicNavbar;
